"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const child_process_1 = require("child_process");
const chalk_1 = __importDefault(require("chalk"));
const cli_core_1 = require("@/cli-core");
const cli_api_1 = require("@/cli-api");
const lang_1 = require("@/service/lang");
const commands_json_1 = __importDefault(require("@/config/commands.json"));
const prompt_1 = __importDefault(require("@/cli-core/prompt"));
const CLIConfig = commands_json_1.default;
// 判断是否为 VS Code 本地调试环境
const isDebug = process.env.DEBUG_ENV === 'true';
const globalNpmRoot = cli_core_1.ChildProcess.runCmdSync('npm root -g');
/**
 * 调试模式，根目录指向当前项目根目录
 * 生产环境：根目录指向指向NPM全局包目录
 * 把coda-cli实际的目录存入环境变量
 */
const debugCliPath = cli_api_1.fs.join(cli_api_1.fs.join(__dirname).split('coda-cli')[0], 'coda-cli');
const cliPath = cli_api_1.fs.join(globalNpmRoot, CLIConfig.packageName);
const cliRealRootPath = isDebug ? debugCliPath : cliPath;
process.env.cliRoootPath = cliRealRootPath;
/**
 * 获取 CLI 配置对象
 */
function getCLIConfig() {
    return {
        packageName: commands_json_1.default.packageName,
        wordsLen: commands_json_1.default.wordsLen,
        name: commands_json_1.default.name,
        commands: commands_json_1.default.commands,
        store: commands_json_1.default.store,
    };
}
/**
 * 显示帮助信息
 * @param name CLI 名称
 * @param commands 命令列表
 */
function showHelp(name, commands) {
    // 定义 type 对应的显示名称
    const typeLabels = {
        coding_assistants: '编程助手',
        dev_tools: '研发工具',
        common_services: '通用服务',
        common_omponents: '通用组件',
    };
    // 按 commands 的 type 属性进行分组
    const groupedMap = commands.reduce((acc, cmd) => {
        const type = cmd.type;
        if (!acc[type]) {
            acc[type] = [];
        }
        acc[type].push(cmd);
        return acc;
    }, {});
    // 计算所有命令的最大长度（包含 name 和空格），用于动态对齐
    let maxCmdLen = 0;
    commands.forEach(cmd => {
        const fullCmd = `${name} ${cmd.command}`;
        if (fullCmd.length > maxCmdLen) {
            maxCmdLen = fullCmd.length;
        }
    });
    const groupSections = [];
    // 直接生成 90 个字符宽度的分隔线
    const dividerLine = '-'.repeat(90);
    // 遍历分组并生成对应的文本块（使用 chalk 进行美化）
    Object.keys(groupedMap).forEach(typeKey => {
        const type = typeKey;
        const cmdList = groupedMap[type];
        // 同一个分组里的元素按 command 字段进行字母升序排序
        cmdList.sort((a, b) => a.command.localeCompare(b.command));
        // 组内命令列表（先对纯文本进行 padEnd 补齐，再包裹 chalk 颜色，防止 ANSI 码影响长度计算）
        const itemsText = cmdList
            .map(cmd => {
            const rawCmd = `${name} ${cmd.command}`;
            const paddedCmd = rawCmd.padEnd(maxCmdLen, ' ');
            const cmdFormatted = chalk_1.default.green(paddedCmd);
            const descFormatted = chalk_1.default.gray(cmd.description);
            return `  ${cmdFormatted} : ${descFormatted}`;
        })
            .join('\n');
        const label = typeLabels[type] || type;
        const labelFormatted = chalk_1.default.magenta.bold(`[ ${label} ]`);
        // 包含分类标题和对应的命令项
        groupSections.push(`${labelFormatted}\n${itemsText}`);
    });
    // 使用 chalk 定义分隔线颜色（优雅的灰色）
    const separator = chalk_1.default.gray(dividerLine);
    const formattedCommands = groupSections.join(`\n${separator}\n`);
    // 组装最终的帮助提示内容
    const usageHeader = chalk_1.default.cyan.bold('Usage:');
    const usageContent = `  ${chalk_1.default.green(name)} ${chalk_1.default.gray('[command]')}`;
    const listTitle = chalk_1.default.cyan.bold(`命令列表(v${getVersion()}):`);
    const helps = `\n${usageHeader}\n${usageContent}\n\n${listTitle}\n${separator}\n${formattedCommands}\n${separator}\n`;
    cli_core_1.CLI.log.info(helps);
}
/**
 * 获取Coda-CLI版本
 * @returns 返回版本号
 */
function getVersion() {
    let pkgPath = cli_api_1.fs.join(cliRealRootPath, 'package.json');
    let pkgJSON = cli_api_1.fs.readFile(pkgPath, true);
    return pkgJSON.version || '1.0.0';
}
/**
 * 检查是否存在相似或匹配的命令
 * @param input 输入的命令
 * @param commands 命令列表
 */
function hasLikeCommand(input, commands) {
    let exsited = false;
    const inputCmd = input.includes('--') ? input.split('--')[0] : input; //判读是否带参数
    let likeList = commands.filter(cmd => {
        if (cmd['command'] === inputCmd) {
            exsited = true;
            return false;
        }
        else {
            let temp = inputCmd.split(' ');
            if (cmd['command'].includes(temp[0])) {
                return true;
            }
            return false;
        }
    });
    return {
        exsited,
        likeList,
    };
}
/**
 * 验证命令合法性
 * @param option 选项/输入内容
 * @param name CLI 名称
 * @param commands 命令列表
 */
function validateCommand(option, name, commands) {
    const { exsited, likeList } = hasLikeCommand(option, commands);
    if (!exsited) {
        if (likeList.length !== 0) {
            let likes = [];
            likeList.forEach(cmd => {
                likes.push(`${name} ${cmd.command}`);
            });
            if (likes.length !== 0) {
                cli_core_1.CLI.log.error(lang_1.Lang.MSG_ERROR, `${lang_1.Lang.NO_COMMAND} "${name} ${option}"`, `${lang_1.Lang.MEAN_SUCH}\n\t${likes.join('\n\t')}`);
                process.exit();
            }
        }
        else {
            cli_core_1.CLI.log.error(lang_1.Lang.MSG_ERROR, `${lang_1.Lang.NO_COMMAND} "${name} ${option}".`);
            process.exit();
        }
    }
    return {
        exsited,
        likeList,
    };
}
/**
 * 执行命令程序文件
 * @param globalNpmRoot
 * @param cliRealRootPath
 * @param executeEntry
 */
function executeProgram(globalNpmRoot, cliRealRootPath, executeEntry) {
    let programPath = isDebug
        ? cli_api_1.fs.join(cliRealRootPath, 'dist', executeEntry) //调试模式访问dist目录下的路径
        : cli_api_1.fs.join(cliRealRootPath, executeEntry); //生产环境访问的路径
    let child = (0, child_process_1.fork)(programPath, [globalNpmRoot], {
        silent: false,
    });
    child.on('error', (error) => {
        console.clear();
        cli_core_1.CLI.log.error(error.message, error.stack);
        autoUpdate();
    });
    child.on('exit', (code) => {
        if (code === 0) {
            autoUpdate();
        }
    });
}
/**
 * 运行命令
 * @param currArgs
 * @param name
 * @param commands
 */
function runCommand(input, name, commands) {
    let cmdOptions = input.join(' '); //实际命令（不带参数）
    let executeEntry = `${cli_api_1.fs.join('generator', input.join('-'), 'index.js')}`; //命令对应的执行文件路径
    const { exsited } = validateCommand(cmdOptions, name, commands);
    if (exsited) {
        cli_core_1.CLI.loading.succeed(lang_1.Lang.CLI_VOLIDATE_CMD_SUCCESS);
        executeProgram(globalNpmRoot, cliRealRootPath, executeEntry);
    }
    else {
        cli_core_1.CLI.log.error(lang_1.Lang.MSG_ERROR, `${lang_1.Lang.NO_COMMAND} "${name} ${input.join(' ')}"`);
        process.exit();
    }
}
/**
 * 获取命令参数（多单词命令的参数）
 * @param input
 */
function getCommandFilterArgs(input) {
    const cmdArgs = {}; //获取命令参数
    const cmd = [];
    input.map((item, index) => {
        if (item.includes('--')) {
            const temp = item.split('--')[1].split('=');
            cmdArgs[temp[0]] = temp[1];
        }
        else {
            cmd.push(item);
        }
    });
    process.env.CODA_CMD_ARGS = JSON.stringify(cmdArgs); //命令参数存入环境变量
    return cmd;
}
/**
 * 检查并自动更新 CLI 或相关依赖
 */
async function autoUpdate() {
    let pkgPath = cli_api_1.fs.join(cliRealRootPath, 'package.json'); // 找到 CLI 自身的 PKG，真实位置在 NPM 全局安装目录下
    cli_core_1.CLI.loading.start(lang_1.Lang.CORE_CHECKING_UPDATE);
    let pkgJSON = cli_api_1.fs.readFile(pkgPath, true);
    let storeUrl = CLIConfig.store;
    let url = cli_api_1.fs.join(storeUrl, CLIConfig.packageName);
    let cliVersion = await cli_api_1.packages.checkVersion(url, pkgJSON.version);
    if (JSON.stringify(cliVersion) === '{}') {
        cli_core_1.CLI.loading.info(lang_1.Lang.CORE_LATEST_VERSION); //CLI版本最新无需操作
    }
    else {
        cli_core_1.CLI.loading.info(lang_1.Lang.CORE_UPDATE_READY); // 升级 CLI 需要切换目录到 NPM 全局安装目录
        cli_core_1.CLI.log.printObject(cliVersion);
        const task = 'npm install -g code-cli --loglevel info --timing';
        if (process.platform === 'win32') {
            cli_core_1.ChildProcess.runCmdLive(task, globalNpmRoot);
        }
        else {
            cli_core_1.CLI.log.warn(lang_1.Lang.CORE_LINUX_INPUT_ROOT_USER_PASSWORD);
            cli_core_1.ChildProcess.runCmdLive(`sudo ${task}`, globalNpmRoot);
        }
    }
}
/**
 * 引导和执行命令的主逻辑（优化版：支持空格分词联动预测）
 */
async function guideCommand() {
    const { wordsLen, name, commands } = getCLIConfig();
    const currArgs = process.argv.slice(2); // 获取实际输入内容
    // 1. 如果用户没有传任何参数（即直接敲了 coda 回车）
    if (currArgs.length === 0) {
        showHelp(name, commands);
        // 启动交互式命令预测搜索组件
        const answers = await prompt_1.default.addQuestions({
            type: 'search',
            name: 'selectedCommand',
            message: '请输入或搜索你要执行的命令:',
            source: async (term) => {
                // 将 commands 转换成 search 组件支持的 choices 格式
                const allCmds = commands.map(cmd => ({
                    name: `${name} ${cmd.command} : ${cmd.description}`,
                    value: cmd.command,
                }));
                // 如果用户没有输入任何内容，默认展示全部命令列表
                if (!term || term.trim() === '') {
                    return allCmds;
                }
                // 💡 核心优化：支持空格分隔的多关键词联动预测
                // 例如用户输入 "add" 后按下空格再输入 "chat"，会将字符串拆分为 ["add", "chat"]
                const keywords = term.toLowerCase().trim().split(/\s+/);
                // 过滤：要求命令名称中必须同时包含所有空格分隔的关键词
                return allCmds.filter(c => {
                    const lowerName = c.name.toLowerCase();
                    return keywords.every(kw => lowerName.includes(kw));
                });
            },
        });
        if (answers.selectedCommand) {
            // 用户选择完命令后，模拟后续执行流程
            const selectedArgs = answers.selectedCommand.split(' ');
            runCommand(selectedArgs, name, commands);
        }
    }
    // 2. 如果用户带了参数，走原有的校验和执行逻辑
    else if (currArgs.length === 1) {
        runCommand(currArgs, name, commands);
    }
    else {
        if (currArgs.length <= wordsLen) {
            const cmd = getCommandFilterArgs(currArgs);
            runCommand(cmd, name, commands);
        }
        else {
            cli_core_1.CLI.log.error(lang_1.Lang.MSG_ERROR, lang_1.Lang.COMMAND_LENGTH_TOO_LONG);
            process.exit();
        }
    }
}
guideCommand();
